import { render, staticRenderFns } from "./Invoicing.vue?vue&type=template&id=8c8e235a&"
import script from "./Invoicing.vue?vue&type=script&lang=js&"
export * from "./Invoicing.vue?vue&type=script&lang=js&"
import style0 from "./Invoicing.vue?vue&type=style&index=0&id=8c8e235a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports